'use client';

import { LineToken } from '@vuddy/components/theme';
import { useState } from 'react';

export interface IUseTabsOptions {
  defaultIndex?: number;
  activeIndex?: number;
  onChangeIndex?: (index: number) => void;
  activeColor?: LineToken;
  inactiveColor?: LineToken;
  activeTabStyle?: string;
  inactiveTabStyle?: string;
}

export const useTabs = ({
  defaultIndex = 0,
  activeIndex: controlledActiveIndex,
  onChangeIndex: setControlledActiveIndex,
  activeColor = 'blackPrimary',
  inactiveColor = 'dividerPrimary',
  activeTabStyle,
  inactiveTabStyle,
}: IUseTabsOptions) => {
  const [uncontrolledActiveIndex, setUncontrolledActiveIndex] =
    useState(defaultIndex);
  const [renderedIndexList, setRenderedIndexList] = useState([defaultIndex]);

  const activeIndex = controlledActiveIndex ?? uncontrolledActiveIndex;
  const setActiveIndex = setControlledActiveIndex ?? setUncontrolledActiveIndex;

  return {
    activeIndex,
    borderColor: {
      active: activeColor,
      inactive: inactiveColor,
    },
    activeColor,
    inactiveColor,
    renderedIndexList,
    changeActiveIndex: (index: number) => {
      setRenderedIndexList(renderedIndex => {
        const curr = [...renderedIndex];
        curr[index] = index;
        return curr;
      });
      setActiveIndex(index);
    },
    activeTabStyle,
    inactiveTabStyle,
  };
};
